import VueSlider from 'vue-slider-component';
import Debug from '@/util/debug';

const debug = Debug('radius-slider');

export default {
  components: {
    VueSlider,
  },
  props: {
    radiuses: {
      validator: value => Array.isArray(value),
    },
    selected: Number,
    unit: String,
  },
  data() {
    return {
      from: this.radiuses[0] || 0,
      to: this.radiuses[this.radiuses.length - 1] || 0,
    };
  },
  computed: {
    stepsCount: function computeStepsCount() {
      return this.radiuses.length - 1;
    },
    selectedIndex: function computeSelectedIndex() {
      return this.checkSelected(this.radiuses);
    },
  },
  watch: {
    radiuses(newRadiuses) {
      this.checkSelected(newRadiuses);
    },
  },
  methods: {
    onCallback(index) {
      debug.info('selected %d', this.radiuses[index]);
      this.$emit('update:selected', this.radiuses[index]);
    },
    formatLabel(index) {
      // First time after element is mounted this is called before refs are linked
      // As soon as refs are set we will receive another call to formatLabel
      // so client won't notice the 'bad' initial value
      if (!this.$refs.vueslider) {
        return '?';
      }

      return this.radiuses[index];
    },
    checkSelected(newRadiuses) {
      if (newRadiuses.length) {
        this.from = newRadiuses[0] || 0;
        this.to = newRadiuses[newRadiuses.length - 1] || 0;

        // Check if value exists in radius array
        const idx = newRadiuses.indexOf(this.selected);
        if (idx === -1) {
          const forceTo = newRadiuses[0];
          debug.warn('invalid radius: resetting to %d', forceTo);
          this.$emit('update:selected', forceTo);
          return 0;
        }
        return idx;
      }
      return 0;
    },
    changeValue(e) {
      // TESTING event
      if (e.detail && e.detail.value) {
        if (this.from <= e.detail.value && this.to >= e.detail.value) {
          const index = e.detail.value - this.from;
          this.$refs.vueslider.setValue(index);
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/radius-slider/RadiusSlider.js